/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import {
  IProviderGroup,
  IProviderGroupCreateREST,
  IProviderGroupUpdateREST,
} from '../../interfaces/provider/provider-group.interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProviderGroupService {
  constructor(private http: HttpClient) {}

  createProviderGroup(group: IProviderGroupCreateREST): Observable<unknown> {
    return this.http.post<IProviderGroupCreateREST>(
      `${getRestEndpoint()}/providergroups`,
      group,
    );
  }

  editProviderGroup(group: IProviderGroupUpdateREST): Observable<unknown> {
    return this.http.put(
      `${getRestEndpoint()}/providergroups/${group.groupId}`,
      group,
    );
  }

  deleteProviderGroup(groupId: string): Observable<unknown> {
    return this.http.delete(`${getRestEndpoint()}/providergroups/${groupId}`);
  }

  getGroupIdByConsumerNumber(
    consumerNumber: string,
  ): Observable<IProviderGroup> {
    return this.http.get(
      `${getRestEndpoint()}/providergroups/consumerId/${consumerNumber}`,
    );
  }

  getProviderGroupByGroupId(groupId: string): Observable<IProviderGroup> {
    return this.http.get(`${getRestEndpoint()}/providergroups/${groupId}`);
  }

  manageGPSettings(groupId: string): Observable<any> {
    return this.http.get(
      `${getRestEndpoint()}/providergroups/managegpsettings/${groupId}`,
    );
  }
}
